var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _mask, _g4, _mask2, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInitialRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 91,
    viewBox: "0 0 201 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9272 27.6207C47.7087 23.435 43.8444 20.3742 39.2558 20.3742C38.6276 20.3742 38.0156 20.4399 37.4197 20.5493C37.5879 19.8596 37.6868 19.1445 37.6868 18.4055C37.6868 13.2111 33.2721 9 27.8254 9C22.704 9 18.4961 12.7252 18.0124 17.4906C12.8742 18.3268 9 22.0411 9 26.4992C9 26.5259 9.00491 26.5519 9.00491 26.5786H11.5716C13.611 26.5786 15.2964 28.0737 15.5453 30H47.0609C48.332 30 49.2749 28.8141 48.9272 27.6207Z",
    fill: "#EEF0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.228 43.2077C192.727 43.2077 192.239 43.2608 191.763 43.3495C191.898 42.7911 191.976 42.2122 191.976 41.614C191.976 37.409 188.455 34 184.111 34C180.026 34 176.67 37.0157 176.284 40.8733C172.185 41.5503 169.095 44.5571 169.095 48.166C169.095 48.1876 169.099 48.2087 169.099 48.2303C169.099 48.2303 168.901 49.4406 169.099 51H199.453C200.467 51 201.219 50.04 200.942 49.0739C199.97 45.6855 196.888 43.2077 193.228 43.2077Z",
    fill: "#EEF0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.928 78.0412C67.5366 78.0412 67.1552 78.0818 66.7839 78.1496C66.8887 77.7226 66.9503 77.2799 66.9503 76.8224C66.9503 73.6069 64.1993 71 60.8053 71C57.614 71 54.9919 73.3061 54.6904 76.2561C51.4886 76.7737 49.0745 79.0731 49.0745 81.8328C49.0745 81.8494 49.0775 81.8655 49.0775 81.882C49.0775 81.882 48.9225 82.8076 49.0775 84H72.7917C73.5837 84 74.1713 83.2659 73.9546 82.5271C73.1953 79.9359 70.7873 78.0412 67.928 78.0412Z",
    fill: "#EEF0F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3967 29H2.6026C1.1676 29 0 30.1676 0 31.6033V33.3967C0 34.8324 1.1676 36 2.6026 36H11.3967C12.8324 36 14 34.8324 14 33.3967V31.6033C14 30.1676 12.8324 29 11.3967 29Z",
    fill: "#EEF0F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 24.4004C42 21.0867 44.6863 18.4004 48 18.4004H100C103.314 18.4004 106 21.0867 106 24.4004V56.8004C106 60.1141 103.314 62.8004 100 62.8004H48C44.6863 62.8004 42 60.1141 42 56.8004V24.4004Z",
    fill: "#EEF0F2",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 24.4004C43 21.639 45.2386 19.4004 48 19.4004H100C102.761 19.4004 105 21.639 105 24.4004V56.8004C105 59.5618 102.761 61.8004 100 61.8004H48C45.2386 61.8004 43 59.5618 43 56.8004V24.4004Z",
    stroke: "#667686",
    strokeWidth: 2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 29.4004C48 27.1913 49.7909 25.4004 52 25.4004H95C97.2091 25.4004 99 27.1913 99 29.4004V52.2004C99 54.4095 97.2091 56.2004 95 56.2004H52C49.7909 56.2004 48 54.4095 48 52.2004V29.4004Z",
    fill: "#D4D9DF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 47C64 43.6863 66.6863 41 70 41H122C125.314 41 128 43.6863 128 47V79.4C128 82.7137 125.314 85.4 122 85.4H70C66.6863 85.4 64 82.7137 64 79.4V47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 47C65 44.2386 67.2386 42 70 42H122C124.761 42 127 44.2386 127 47V79.4C127 82.1614 124.761 84.4 122 84.4H70C67.2386 84.4 65 82.1614 65 79.4V47Z",
    stroke: "#667686",
    strokeWidth: 2
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 52C71 49.7909 72.7909 48 75 48H118C120.209 48 122 49.7909 122 52V74.8C122 77.0091 120.209 78.8 118 78.8H75C72.7909 78.8 71 77.0091 71 74.8V52Z",
    fill: "#D4D9DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81 55C79.8954 55 79 55.8954 79 57V70C79 71.1046 79.8954 72 81 72H99C100.105 72 101 71.1046 101 70V57C101 55.8954 100.105 55 99 55H81ZM115 56L104 59.8182V66.1818L115 70V56Z",
    fill: "#5E99E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.4 42.6C148.4 41.7163 149.116 41 150 41H158.8C159.684 41 160.4 41.7163 160.4 42.6C160.4 43.4837 159.684 44.2 158.8 44.2H150C149.116 44.2 148.4 43.4837 148.4 42.6Z",
    fill: "#84BBF9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 7C88 3.68629 90.6863 1 94 1H162C165.314 1 168 3.68629 168 7V50C168 53.3137 165.314 56 162 56H94C90.6863 56 88 53.3137 88 50V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 7C89 4.23858 91.2386 2 94 2H162C164.761 2 167 4.23858 167 7V50C167 52.7614 164.761 55 162 55H94C91.2386 55 89 52.7614 89 50V7Z",
    stroke: "#667686",
    strokeWidth: 2
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 14C95 10.6863 97.6863 8 101 8H154C157.314 8 160 10.6863 160 14V43C160 46.3137 157.314 49 154 49H101C97.6863 49 95 46.3137 95 43V14Z",
    fill: "#FFCB0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 12C95 9.79086 96.7909 8 99 8H156C158.209 8 160 9.79086 160 12V45C160 47.2091 158.209 49 156 49H99C96.7909 49 95 47.2091 95 45V12Z",
    fill: "#EEF0F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 19C118 22.3129 115.314 25 112 25C108.686 25 106 22.3129 106 19C106 15.6871 108.686 13 112 13C115.314 13 118 15.6871 118 19Z",
    fill: "#F6CB0F"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 18,
    width: 39,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.922 45.8928C159.922 47.4801 158.717 48.7985 157.177 48.9796H121.949V18.0059L159.922 18.0059V45.8928Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.142 19.1556L121.949 35.3806L135.979 48.9796H173.475L143.707 19.1556C142.177 17.6226 139.673 17.6226 138.142 19.1556Z",
    fill: "#4D86EC"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 30,
    width: 38,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4973 48.9787C96.5381 48.7957 95.007 47.4782 95.007 45.8924V30.0566L132.264 30.0566V48.9787H98.4973Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.665 31.0717L90.0003 48.9787H106.555H132.264L119.196 36.3137L113.802 31.0847C112.393 29.7187 110.081 29.7137 108.665 31.0717Z",
    fill: "#4D86EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 39,
    y: 17.4004,
    width: 70,
    height: 50.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 61,
    y: 40,
    width: 70,
    height: 50.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 85,
    y: 0,
    width: 86,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialRecommendations);
export default __webpack_public_path__ + "static/media/initialRecommendations.41f8addc87fff705075fc5c12247de09.svg";
export { ForwardRef as ReactComponent };